import * as React from "react";
import { useSelector } from "react-redux";
import { TooltipHost } from "@fluentui/react";

import { TEXT } from "../../../../../shared/constants/texts";
import ConfigService from "../../../../../shared/services/configService";
const configService = new ConfigService();

const AgreementDetails: React.FC = () => {
  const state = useSelector((state: any) => state.addToIciSlice);
  const { selectedAgreement } = state;

  const openWindowInBrowserWrapper = (url) => {
    const openWindowInBrowser = Office.context.ui;
    if (Office.context.requirements.isSetSupported("OpenBrowserWindowApi", "1.1")) {
      openWindowInBrowser.openBrowserWindow(url);
    } else {
      window.open(url);
    }
  };

  const openInICI = () => {
    let icmUrl = configService.getIcmUrl();
    if (icmUrl.endsWith("/")) {
      icmUrl = icmUrl.slice(0, -1);
    }
    const urlToOpenInICI =
      icmUrl +
      "/Agreement/Details?entityName=" +
      selectedAgreement.entityName +
      "&id=" +
      selectedAgreement.sysId +
      "&showTab=summary";
    openWindowInBrowserWrapper(urlToOpenInICI);
  };

  const name = selectedAgreement
    ? selectedAgreement.name
      ? selectedAgreement.name
      : selectedAgreement.iCMAgreementCode
    : "";
  const status = selectedAgreement && selectedAgreement.status ? selectedAgreement.status : "";
  const contractTypeName = selectedAgreement && selectedAgreement.entityName ? selectedAgreement.entityName : "";

  const onPressEnterOpenInICI = (e) => {
    if (e.key === TEXT.ENTER || e.keyCode === TEXT.ENTER_KEY_CODE) {
      openInICI();
    }
  };

  return (
    <div className="agreement-details-single-email-upload">
      <div className="name" onClick={openInICI} tabIndex={1} onKeyDown={onPressEnterOpenInICI}>
        <TooltipHost id="id-agreement-name-details" content={name}>
          {name}
        </TooltipHost>
      </div>
      <div className="ct-name-status">
        <div className="ct-name">
          <TooltipHost id="id-agreement-contract-type-details" content={contractTypeName}>
            {contractTypeName}
          </TooltipHost>
        </div>
        <div className="status">
          <TooltipHost id="id-agreement-status-details" content={status}>
            {status}
          </TooltipHost>
        </div>
      </div>
    </div>
  );
};

export default AgreementDetails;
